import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('invite_your_teammate_to_t_the_accounting_system'),
    description: defineMessage('if_you_cant_connect_the_approvalmax_as_an_admin'),
    alert: defineMessage('your_colleague_will_rec_o_the_accounting_system'),
    adminAble: defineMessage('the_admin_will_be_able_to'),
    adminAble1: defineMessage('connect_the_approvalmax_org_to_your_gl'),
    adminAble2: defineMessage('set_up_new_workflows'),
    adminAble3: defineMessage('manage_integrations'),
    adminAble4: defineMessage('add_new_users_1'),
    adminAble5: defineMessage('view_and_create_request_reports'),
    adminAble6: defineMessage('submit_and_approve_requests'),
    buttonBack: defineMessage('back'),
    buttonInvite: defineMessage('invite_teammate'),
};
